const ProjectsList = [
    {
        "uid": "cc95526f-fa88-4bce-91f6-7571aeaf3b0a",
        "title": "Cyber Security",
        "description": "Hands-on penetration testing labs, CTF writeups, and security research covering web, network, and cloud attack vectors.",
        "url": "https://github.com/hhphu/InfoSec",
        "icon": "ri-shield-keyhole-line",
        "tags": ["Pentesting", "CTF", "Web Security", "Network"]
    },
    {
        "uid": "23dca6ac-164f-44d6-a389-121b110de93d",
        "title": "Cloud Security",
        "description": "Cloud security architecture, IAM hardening, and security best practices across AWS environments and DevSecOps pipelines.",
        "url": "https://github.com/hhphu/hhphu-cloud",
        "icon": "ri-cloud-line",
        "tags": ["AWS", "IAM", "Cloud Security", "DevSecOps"]
    },
    {
        "uid": "a816d2d0-b024-4e4e-b9d9-bba6977e6544",
        "title": "In Phu Sec Notes",
        "description": "Comprehensive security knowledge base covering cloud security, vulnerability research, and DevOps practices — built for practitioners.",
        "url": "https://inphusecnotes.hhphu.com",
        "icon": "ri-book-2-line",
        "tags": ["Cloud", "Cybersecurity", "DevOps", "Docs"]
    },
    {
        "uid": "0a9a5146-115f-494b-8b37-88a63a93db59",
        "title": "In Phu Sec Blogs",
        "description": "Security blog featuring in-depth writeups, tutorials, and insights on ethical hacking, QA automation, and security engineering.",
        "url": "https://www.hqphu.com/",
        "icon": "ri-article-line",
        "tags": ["Security", "Writeups", "QA", "Tutorials"]
    },
]

export default ProjectsList;
